import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/*
 * Class name helper: clsx + tailwind-merge, taught bPanel's token scale so `text-14` (a size) and
 * `text-ink` (a colour) never cancel each other out.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['12', '13', '14', '15', '16', '17', '18', '20', '22', '24', '28', '32', '40', '48', '56', '64'],
      radius: ['panel'],
      shadow: ['card', 'card-hover', 'brand', 'mock', 'focus', 'float', 'pop', 'panel', 'button-primary'],
      font: ['display'],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
